import Navbar from './Navbar'
import Items from './types/Items'

export default function Type() {
  return (
    <>
      <Navbar search={true} nav={true} breadcrumb={false} />
      <Items />
    </>
  )
}
